import { AuiIf, ThreadMessage, ThreadPrimitive, useAuiState } from '@assistant-ui/react';
import { type FC } from 'react';
import { AssistantAvatarContext } from './AssistantAvatarContext';
import { AssistantMessage } from './AssistantMessage';
import { Composer } from './Composer';
import { Suggestions } from './Suggestions';
import { type ThreadConfig } from './ThreadConfig';
import { UserMessage } from './UserMessage';
import { WelcomeContent } from './WelcomeContent';
import './Thread.scss';

const getSuggestions = (messages: readonly ThreadMessage[]) => {
  if (messages.length === 0) {
    return undefined;
  }
  const lastMessage = messages[messages.length - 1];
  const lastSuggestions = lastMessage?.metadata.custom['suggestions'] as string[] | undefined;
  if (lastSuggestions && lastSuggestions.length > 0) {
    return lastSuggestions;
  } else {
    return undefined;
  }
};

export const Thread: FC<ThreadConfig> = ({ avatar, welcome }) => {
  const messages = useAuiState(({ thread }) => thread.messages);
  const suggestions = getSuggestions(messages);
  return (
    <ThreadPrimitive.Root asChild>
      <AssistantAvatarContext.Provider value={avatar}>
        <ThreadPrimitive.Viewport className={'chat-viewport'}>
          <WelcomeContent {...welcome} />
          <ThreadPrimitive.Messages>
            {({ message }) => {
              if (message.role === 'user') {
                return <UserMessage />;
              }
              return <AssistantMessage />;
            }}
          </ThreadPrimitive.Messages>
          <AuiIf condition={({ thread }) => !thread.isEmpty}>
            <div className={'chat-spacer'} />
          </AuiIf>
          <Suggestions suggestions={suggestions} />
          <Composer />
        </ThreadPrimitive.Viewport>
      </AssistantAvatarContext.Provider>
    </ThreadPrimitive.Root>
  );
};
Thread.displayName = 'Thread';
